/*@ngInject*/
const  DateFilterController = function ($scope, $q, advancedFilterModel, coreMediator, coreConstant,
                                        formatUtil, localization, dataSetUtil) {

    this.$onInit = function () {

        let criterionTemplate = this.criterionTemplate,
            dataSetName = criterionTemplate.dataSetName,
            submissionUri = !_.isNil(this.submission) ? 'com.firstbest.underwriting.submission.Submission:' + this.submission.id : null,
            variableName = this.criterionTemplate.variableName,
            dataSetParams = dataSetUtil.getDataSetParamsByName(dataSetName, variableName, submissionUri);

        this.customRange = false;
        this.isOpen = true;

        this.tooltip = {
            delay: 750
        };

        this.itemsList = [];

        localization.getTranslationsByKeys([this.translationsKey, 'advancedFilter']).then((translations) => {
            this.placeholder = _.get(translations.dateFilter, this.criterionTemplate.variableName + '.placeholder') || translations.placeholder;
            this.tooltip.message = translations.removeButtonTooltip;
        });

        return dataSetUtil.getDataItems(dataSetParams).then(function(items){
            this.setItemsList(items);
            return items;
        }.bind(this));
    };

    this.formatAsSelector = function (nameString) {
        return nameString ? formatUtil.formatAsSelector(nameString) : '';
    };

    this.setItemsList = function (itemsList) {
        this.itemsList = itemsList;
        this.filterItems();
        this.updateDropdownSelectedValue();
    };

    this.filterItems = function (searchText) {
        let filteredItemsList = [];

        if (!_.isEmpty(searchText)) {
            filteredItemsList = _.filter(this.itemsList, function (item) {
                return _.includes(item.name.toLowerCase(), searchText.toLowerCase());
            });
        } else if (_.isArray(this.itemsList)) {
            filteredItemsList = this.itemsList;
        }

        if (this.searchableList && filteredItemsList.length > 150) {
            this.showLongListWarning(filteredItemsList.length);
        } else {
            this.filteredItemsList = filteredItemsList;
        }
    };

    this.updateDropdownSelectedValue = function () {
        let criterionValue = this.criterionTemplate.value,
            selectedValue = null;
        if (!_.isNil(criterionValue)) {
            if (_.startsWith(criterionValue, 'SPECIFIED::')) {
                selectedValue = _.find(this.itemsList, {value: 'Custom Range'});
                this.customRange = true;
            } else {
                selectedValue = _.find(this.itemsList, {value: criterionValue});
            }

            if (!_.isNil(selectedValue)) {
                this.dropdownSelectedValue = selectedValue;
            } else {
                this.dropdownSelectedValue = _.intersectionWith(this.itemsList, _.split(criterionValue, '::'),
                    function (dataItem, criterionItem) {
                        return dataItem.value === criterionItem;
                    }
                );
            }
        } else {
            this.dropdownSelectedValue = null;
        }
    };

    this.handleSelect = function (select) {
        let selectedItems = null;
        if (_.isArray(select.selected)) {
            selectedItems = '';
            _.forEach(select.selected, function (selectedItem) {
                selectedItems += selectedItem.value + '::';
            });
            selectedItems = selectedItems.substring(0, selectedItems.lastIndexOf('::'));
        } else if (!_.isNil(select.selected)) {
            selectedItems = select.selected.value;
        }

        if (selectedItems === 'Custom Range') {
            this.customRange = true;
            this.criterionTemplate.value = 'ALL';
        } else {
            this.customRange = false;
            this.criterionTemplate.value = selectedItems;
        }
        $scope.$emit(coreConstant.event.FILTER_UPDATED, this.advancedFilterType);
    };

    this.getComponentId = function (filterCriterionTemplate) {
        return this.advancedFilterType + 'AdvancedFilterType ' + filterCriterionTemplate.variableName;
    };

    this.handleRemove = function () {
        advancedFilterModel.unselectFilterCriterion(this.advancedFilterType, this.criterionTemplate.id);
        $scope.$emit(coreConstant.event.FILTER_UPDATED, this.advancedFilterType);
    };

    this.customDateRangeUpdated = function (value) {
        this.criterionTemplate.value = value;
        $scope.$emit(coreConstant.event.FILTER_UPDATED, this.advancedFilterType);
    };

    $scope.$on(coreConstant.event.FILTER_CLEARED, function (event, criterionTemplateId) {
        if (criterionTemplateId === this.criterionTemplate.id) {
            this.criterionTemplate.value = null;
            this.customRange = false;
            this.updateDropdownSelectedValue();
        }
    }.bind(this));
};
angular.module('umCore').controller('dateFilterController', DateFilterController);
